import { GetServerSideProps, NextPage } from 'next';
import { fetchCampaignWebview } from './api/fetchCampaignWebview';
import React from 'react';
import { createUseStyles } from '../hooks/jss';

interface ViewOnlinePageProps {
  htmlContent?: string;
  error?: string;
}

const useStyles = createUseStyles({
  iframe: {
    width: '100%',
    height: '100vh',
    border: 'none',
    margin: 0,
    padding: 0
  }
});

const ViewOnlinePage: NextPage<ViewOnlinePageProps> = ({ htmlContent, error }) => {
  const classes = useStyles();

  if (error) {
    throw new Error(error);
  }

  if (!htmlContent) {
    return null;
  }

  return (
    <iframe
      srcDoc={htmlContent}
      className={classes.iframe}
      sandbox='allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox'
      title='Email Campaign'
    />
  );
};

export const getServerSideProps: GetServerSideProps<ViewOnlinePageProps> = async context => {
  const { hashId } = context.query || {};
  const { req } = context;

  if (!hashId || typeof hashId !== 'string') {
    return { notFound: true };
  }

  try {
    const result = await fetchCampaignWebview(hashId, req.headers.host || '');

    if ('notFound' in result) {
      return { notFound: true };
    }

    if ('error' in result) {
      return { props: { error: result.error } };
    }

    return { props: { htmlContent: result.htmlContent } };
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error in getServerSideProps:', error);
    return { props: { error: 'Internal server error' } };
  }
};

// eslint-disable-next-line import/no-default-export
export default ViewOnlinePage;
